import * as React from "react";
import {observer} from "mobx-react";
import {Grid} from "@mui/material";
import Typography from "@mui/material/Typography";
import FormColumn from "../../../forms/FormColumn";
import FormRow from "../../../forms/FormRow";
import FormTextField from "../../../components/fields/FormTextField";
import FormAutocompleteField from "../../../components/fields/FormAutocompleteField";
import FormGooglePlacesAutocompleteField from "../../../components/fields/FormGooglePlacesAutocompleteField";
import GoogleAddressMap from "../../../components/maps/GoogleAddressMap";
import LineButton from "../../../components/buttons/LineButton";

function LeadDeliverySiteScreen({form, onRemove}) {
    const mapFeature = form.mapFeature;

    return (
        <FormColumn>
            <FormRow>
                <FormTextField label="Nombre del Punto de Entrega" form={form} fieldName="name"/>
                <FormGooglePlacesAutocompleteField
                    label="Domicilio"
                    form={form}
                    fieldName="address"
                    onPlaceSelected={(placeData) => mapFeature.updateFromPlaceSelection(placeData)}
                    isGoogleMapsLoaded={mapFeature.isGoogleMapsLoaded}
                />
                <FormAutocompleteField
                    label="Provincia"
                    form={form}
                    fieldName="jurisdiction"
                    options={form.jurisdictionOptions()}
                    readOnly={mapFeature.jurisdictionWasAutocompleted}
                />
            </FormRow>
            <FormRow>
                <FormTextField
                    label="Localidad"
                    form={form}
                    fieldName="city"
                    disabled={mapFeature.cityWasAutocompleted}
                />
                <FormTextField
                    label="Código Postal"
                    form={form}
                    fieldName="postalCode"
                    disabled={mapFeature.postalCodeWasAutocompleted}
                />
            </FormRow>
            <FormRow>
                <Grid item xs={12}>
                    <GoogleAddressMap feature={mapFeature} form={form} fieldName="address"/>
                </Grid>
            </FormRow>
            <Typography color={form.isOutOfZone ? 'warning.main' : 'success.main'}>
                {form.zoneDescription}
            </Typography>
            <div>
                <LineButton onClick={onRemove}>Quitar</LineButton>
            </div>
        </FormColumn>
    );
}

export default observer(LeadDeliverySiteScreen);
